import { render, staticRenderFns } from "./events.datagrid.vue?vue&type=template&id=edd21e98&scoped=true&"
import script from "./events.datagrid.vue?vue&type=script&lang=js&"
export * from "./events.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./events.datagrid.vue?vue&type=style&index=0&id=edd21e98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd21e98",
  null
  
)

export default component.exports